// @flow @jsx h

import { Byline, ResponsiveVideo } from '@nrk/dh-feature-components'
import { h } from 'preact'
import Skew from '../Skew'
import style from './index.css'

import type { Props as BaseProps, Viewport } from './types'

type Props = BaseProps & {
  viewport: Viewport
}

function Header (props: Props) {
  const { mediaBaseUrl, viewport } = props
  const { authors, intro, leadMedia, title } = props.data

  return (
    <header className={style.article__header}>
      <div className={style.article__leadMediaWrapper}>
        <Skew className={style.article__headerTopSkew} position='bottom' />
        <ResponsiveVideo
          className={style.article__leadMedia}
          loop
          playing
          playsInline
          preload='auto'
          muted
          resolution720p={{
            poster: `${mediaBaseUrl}${leadMedia.resolution720p.poster}`,
            sources: leadMedia.resolution720p.sources.map(source => {
              return {
                type: source.type,
                src: `${mediaBaseUrl}${source.src}`
              }
            })
          }}
          resolution1080p={{
            poster: `${mediaBaseUrl}${leadMedia.resolution1080p.poster}`,
            sources: leadMedia.resolution1080p.sources.map(source => {
              return {
                type: source.type,
                src: `${mediaBaseUrl}${source.src}`
              }
            })
          }}
          viewport={viewport}
        />
        <Skew className={style.article__headerBottomSkew} position='top' />
      </div>

      <div className={style.article__headerText}>
        <h1
          className={style.article__title}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {intro && (
          <p
            className={style.article__intro}
            dangerouslySetInnerHTML={{ __html: intro }}
          />
        )}
        <Byline className={style.article__authors} authors={authors} />
      </div>
    </header>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/v1/components/Article/Header.js